import { Routes, Route } from 'react-router';
import ListRrhhView from './views/ListRrhhView';
import CreateUpdateRrhhView from './views/CreateUpdateRrhhView';
import ListRolesView from './views/ListRolesView';
import CreateRolView from './views/CreateRolView';

export default function RrhhRouter() {
    return (
        <Routes>
            <Route path="/" element={<ListRrhhView />} />
            <Route path="/crear" element={<CreateUpdateRrhhView />} />
            <Route path="/editar/:hashCode" element={<CreateUpdateRrhhView />} />
            <Route path="/roles" element={<ListRolesView />} />
            <Route path="/roles/crear" element={<CreateRolView />} />
            <Route path="/roles/crear/:hashCode" element={<CreateRolView />} />
        </Routes>
    )
}